<section [ngStyle]="calculateColumnsContainer()" class="title-container">
  <ng-container *ngFor="let column of columns">
    <div
      [ngClass]="{
        'column-title-sort':
          column.isSort &&
          activeColumnSort === column.sortField &&
          selectedSort,
        'column-title': !(
          column.isSort &&
          activeColumnSort === column.sortField &&
          selectedSort
        ),
        pointer: column.isSort
      }"
      (click)="column.isSort && sort(column)"
      *ngIf="showColumn(column)"
    >
      <div [ngStyle]="{ 'justify-self': column.align }">
        <div class="truncate-text" [innerHTML]="column.columnTitle"></div>
      </div>
      <mat-icon
        class="material-icons-solid"
        *ngIf="
          selectedSort === 'descending' && activeColumnSort === column.sortField
        "
        >arrow_drop_down
      </mat-icon>
      <mat-icon
        class="material-icons-solid"
        *ngIf="
          selectedSort === 'ascending' && activeColumnSort === column.sortField
        "
        >arrow_drop_up
      </mat-icon>
    </div>
  </ng-container>
</section>
